<div>
  <p class="auth-desc auth-register-desc">
    {{ 'pages.register.step1.description' | i18n }}
  </p>
  
  <form [formGroup]="step1Form" class="auth-form" (ngSubmit)="nextStep()">
    
    <div class="input-group">
      <umkt-custom-input 
        formControlName="cnpj" 
        id="cnpj" 
        [ariaLabel]="'pages.register.step1.cnpj.label' | i18n" 
        [placeholder]="'pages.register.step1.cnpj.placeholder' | i18n"
        mask="AA.AAA.AAA/AAAA-00">
      </umkt-custom-input>
      
      <div *ngIf="step1Form.get('cnpj')?.errors?.['invalidCNPJ'] && step1Form.get('cnpj')?.touched" class="field-error">
        {{ 'pages.register.step1.cnpj.errorInvalid' | i18n }}
      </div>
      <div *ngIf="step1Form.get('cnpj')?.errors?.['documentExists'] && (step1Form.get('cnpj')?.touched || step1Form.get('cnpj')?.dirty)"
        class="field-error">
        {{ 'pages.register.step1.cnpj.errorExists' | i18n }}
      </div>
    </div>

    <div class="input-group">
      <umkt-custom-input 
        formControlName="razaoSocial" 
        id="razaoSocial" 
        [ariaLabel]="'pages.register.step1.companyName.label' | i18n"
        [placeholder]="'pages.register.step1.companyName.placeholder' | i18n" 
        [maxlength]="255" 
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      
      <div *ngIf="step1Form.get('razaoSocial')?.hasError('maxlength') && step1Form.get('razaoSocial')?.touched" class="field-error">
        {{ 'pages.register.step1.companyName.errorMax' | i18n }}
      </div>
    </div>

    <div class="input-group">
      <umkt-custom-input 
        formControlName="nomeFantasia" 
        id="nomeFantasia" 
        [ariaLabel]="'pages.register.step1.tradingName.label' | i18n"
        [placeholder]="'pages.register.step1.tradingName.placeholder' | i18n" 
        [maxlength]="255"
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      
      <div *ngIf="step1Form.get('nomeFantasia')?.hasError('maxlength') && step1Form.get('nomeFantasia')?.touched" class="field-error">
        {{ 'pages.register.step1.tradingName.errorMax' | i18n }}
      </div>
    </div>

    <div class="input-group">
      <umkt-custom-input 
        formControlName="telefoneEmpresa" 
        id="telefoneEmpresa" 
        [ariaLabel]="'pages.register.step1.phone.label' | i18n"
        [placeholder]="'pages.register.step1.phone.placeholder' | i18n" 
        type="tel"
        mask="(00) 0000-0000 ||(00) 00000-0000">
      </umkt-custom-input>
      
      <div *ngIf="step1Form.get('telefoneEmpresa')?.errors?.['invalidPhone'] && step1Form.get('telefoneEmpresa')?.touched" class="field-error">
        {{ 'pages.register.step1.phone.errorInvalid' | i18n }}
      </div>
    </div>
    <ustore-button type="submit" [text]="'pages.register.step1.nextButton' | i18n" [disabled]="step1Form.invalid || isLoadingCNPJ || loading"
      [full]="true" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'" [format]="'filled'" [size]="'medium'"
      [rounded]="'default'"
      [icon]="{ name: 'arrow_forward', type: 'material-icons', position: 'right' }">
    </ustore-button>
    
    <div class="auth-register">
      {{ 'shared.auth.hasAccount' | i18n }} <a (click)="goToLogin()">{{ 'shared.buttons.login' | i18n }}</a>
    </div>
  </form>
</div>


